import { render, staticRenderFns } from "./RequestCustomerView.vue?vue&type=template&id=04ba3f2a&scoped=true&"
import script from "./RequestCustomerView.vue?vue&type=script&lang=js&"
export * from "./RequestCustomerView.vue?vue&type=script&lang=js&"
import style0 from "./RequestCustomerView.vue?vue&type=style&index=0&id=04ba3f2a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ba3f2a",
  null
  
)

export default component.exports